export default __webpack_public_path__ + "static/charter-amendments-og-90bd3d5417f5aefb2cd9d975ed20d807.png";